export class TransportMode {
    constructor(private _tMCode: string, private _tMValue: string) {
        
    }

    get tMCode(): string {
        return this._tMCode;
    }

    get tMValue(): string {
        return this._tMValue;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestList/models/transportMode.ts
 **/